import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  & > * {\n    width: 100%;\n  }\n  ", "\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex-shrink: 0;\n  ", "\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  * ~ & {\n    ", "\n  }\n  & > * {\n    width: 100%;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  * ~ & {\n    ", "\n  }\n  & > * {\n    width: 100%;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  & > * {\n    width: 100%;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Base, H1, H4, PriceMedium, Small, Ul } from '../Typography';
import { HERO_BOTTOM_PADDING, HERO_CENTER_BUTTON_PADDING, HERO_CONTENT_PADDING, HERO_HINT_PADDING, HERO_KICKER_PADDING, HERO_LINK_PADDING, HERO_LIST_HORIZONTAL_OFFSET, HERO_LIST_PADDING, HERO_LIST_VERTICAL_OFFSET, HERO_PRICE_BOTTOM_MARGIN, HERO_RIGHT_BUTTON_LEFT_PADDING, HERO_RIGHT_BUTTON_TOP_PADDING, HERO_TITLE_PADDING } from './constants';
import Flex from '../Flex';
import Button, { TextButton } from '../Button';
import { IconDefault } from '../SvgIcon';
import { ICON_LARGE_SIZE, ICON_SIZE } from '../constants';
import { getPx } from '../helpers/common';
import { $hideMixin, $showMixin } from '../mixins/layout';
import { modifyProps } from '../helpers/props';
import { styleArrayForBreakpoints } from '../helpers/media-style';
import { modifyByBreakpoints } from '../helpers/media-modify';
import { combineByBreakpoints } from '../helpers/media-combine';
import { EMPTY_ARRAY, EMPTY_PROPS } from '../helpers/types';
import { alignSelf } from '../style/flex-align';
import { width } from '../style/width';
import { paddingBottom } from '../style/padding-bottom';
import { paddingTop } from '../style/padding-top';
import { marginBottom } from '../style/margin-bottom';
var IS_MOBILE = {
  xs: true,
  sm: false
};
var IS_DESKTOP = {
  xs: false,
  md: true
};
var VERTICAL_LINK = {
  xs: true,
  lg: false
};
var CONTENT_DIRECTION = modifyProps(IS_MOBILE, function (isMobile) {
  return isMobile ? 'ttb' : 'ltr';
});
var LIST_INLINE = modifyProps(IS_MOBILE, function (isMobile) {
  return !isMobile;
});
var Wrapper = styled(Flex)(_templateObject());
var ContentWrapper = styled(Flex)(_templateObject2(), function (_ref) {
  var center = _ref.center;
  return center && "margin: 0 auto;";
}, function (_ref2) {
  var $restrict = _ref2.$restrict;
  return $restrict && width({
    xs: '100%',
    md: '90%',
    lg: '80%',
    xl: '75%'
  });
}, $showMixin);
var LinkWrapper = styled(Flex)(_templateObject3(), paddingTop(HERO_LINK_PADDING), $showMixin);
var CenterButtonWrapper = styled(Flex)(_templateObject4(), paddingTop(HERO_CENTER_BUTTON_PADDING));
var BodyWrapper = styled.div(_templateObject5());
var HintWrapper = styled.div(_templateObject6(), paddingTop(HERO_HINT_PADDING));
var ListWrapper = styled.div(_templateObject7(), paddingTop(HERO_LIST_PADDING));
var RightButtonWrapper = styled.div(_templateObject8(), function (_ref3) {
  var value = _ref3.$alignSelf;
  return alignSelf(value);
}, function (_ref4) {
  var $vertical = _ref4.$vertical;
  return styleArrayForBreakpoints([$vertical, HERO_RIGHT_BUTTON_TOP_PADDING, HERO_RIGHT_BUTTON_LEFT_PADDING], function (_ref5) {
    var $vertical = _ref5[0],
        $paddingTop = _ref5[1],
        $paddingLeft = _ref5[2];
    return $vertical ? "padding-top: " + getPx($paddingTop) + ";" : "padding-left: " + getPx($paddingLeft) + ";";
  });
});
var PriceWrapper = styled.div(_templateObject9(), marginBottom(HERO_PRICE_BOTTOM_MARGIN));
var ContentFlex = styled(Flex)(_templateObject10(), paddingTop(HERO_CONTENT_PADDING));
var HeadingWrapper = styled.div(_templateObject11(), paddingBottom(HERO_CONTENT_PADDING), $showMixin);
var StyledH1 = styled(H1)(_templateObject12(), paddingBottom(HERO_TITLE_PADDING));
StyledH1._size = H1._size;
var StyledH4 = styled(H4)(_templateObject13(), paddingBottom(HERO_KICKER_PADDING));
StyledH4._size = H4._size;
var StyledTextButton = styled(TextButton)(_templateObject14(), $showMixin, $hideMixin);

var _ref8 = /*#__PURE__*/React.createElement(IconDefault, {
  hasArrow: true,
  arrow: 'bottom',
  size: ICON_LARGE_SIZE
});

var _ref9 = /*#__PURE__*/React.createElement(IconDefault, {
  hasArrow: true,
  arrow: 'right',
  size: ICON_SIZE
});

var Hero = /*#__PURE__*/React.forwardRef(function (_ref6, forwardedRef) {
  var _ref6$center = _ref6.center,
      center = _ref6$center === void 0 ? false : _ref6$center,
      linkTitle = _ref6.linkTitle,
      _ref6$linkProps = _ref6.linkProps,
      linkProps = _ref6$linkProps === void 0 ? EMPTY_PROPS : _ref6$linkProps,
      onLinkClick = _ref6.onLinkClick,
      centerButtonTitle = _ref6.centerButtonTitle,
      centerButtonSubTitle = _ref6.centerButtonSubTitle,
      _ref6$centerButtonPro = _ref6.centerButtonProps,
      centerButtonProps = _ref6$centerButtonPro === void 0 ? EMPTY_PROPS : _ref6$centerButtonPro,
      onCenterButtonClick = _ref6.onCenterButtonClick,
      priceTitle = _ref6.priceTitle,
      rightButtonTitle = _ref6.rightButtonTitle,
      rightButtonSubTitle = _ref6.rightButtonSubTitle,
      _ref6$rightButtonProp = _ref6.rightButtonProps,
      rightButtonProps = _ref6$rightButtonProp === void 0 ? EMPTY_PROPS : _ref6$rightButtonProp,
      onRightButtonClick = _ref6.onRightButtonClick,
      _ref6$rightButtonAlig = _ref6.rightButtonAlignY,
      rightButtonAlignY = _ref6$rightButtonAlig === void 0 ? 'flex-end' : _ref6$rightButtonAlig,
      title = _ref6.title,
      kickerTitle = _ref6.kickerTitle,
      bodyTitle = _ref6.bodyTitle,
      hintTitle = _ref6.hintTitle,
      _ref6$paddingTop = _ref6.paddingTop,
      paddingTop = _ref6$paddingTop === void 0 ? 0 : _ref6$paddingTop,
      _ref6$paddingBottom = _ref6.paddingBottom,
      paddingBottom = _ref6$paddingBottom === void 0 ? HERO_BOTTOM_PADDING : _ref6$paddingBottom,
      _ref6$listItems = _ref6.listItems,
      listItems = _ref6$listItems === void 0 ? EMPTY_ARRAY : _ref6$listItems,
      _ref6$verticalLink = _ref6.verticalLink,
      verticalLink = _ref6$verticalLink === void 0 ? VERTICAL_LINK : _ref6$verticalLink,
      _ref6$centerLink = _ref6.centerLink,
      centerLink = _ref6$centerLink === void 0 ? true : _ref6$centerLink,
      _ref6$showLink = _ref6.showLink,
      showLink = _ref6$showLink === void 0 ? true : _ref6$showLink,
      props = _objectWithoutPropertiesLoose(_ref6, ["center", "linkTitle", "linkProps", "onLinkClick", "centerButtonTitle", "centerButtonSubTitle", "centerButtonProps", "onCenterButtonClick", "priceTitle", "rightButtonTitle", "rightButtonSubTitle", "rightButtonProps", "onRightButtonClick", "rightButtonAlignY", "title", "kickerTitle", "bodyTitle", "hintTitle", "paddingTop", "paddingBottom", "listItems", "verticalLink", "centerLink", "showLink"]);

  var hasRightButton = !!rightButtonTitle;
  var hasCenteredLink = useMemo(function () {
    return modifyByBreakpoints(centerLink, function (centerLink) {
      return center || centerLink;
    });
  }, [center, centerLink]);
  var listTextAlign = useMemo(function () {
    return modifyProps(IS_MOBILE, function (isMobile) {
      return center && !isMobile ? 'center' : 'left';
    });
  }, [center]);
  var rightButtonAlignSelf = useMemo(function () {
    return combineByBreakpoints([IS_MOBILE, IS_DESKTOP, rightButtonAlignY], function (_ref7) {
      var isMobile = _ref7[0],
          isDesktop = _ref7[1],
          alignY = _ref7[2];
      return !(!isDesktop || center) ? 'flex-end' : !isMobile ? alignY : 'unset';
    });
  }, [center, rightButtonAlignY]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    ref: forwardedRef,
    fullWidth: true,
    fullHeight: true,
    direction: "ttb",
    alignItems: "stretch",
    flexGrow: 1,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom
  }, props), /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1,
    direction: "ttb",
    justifyContent: center ? 'center' : 'flex-end',
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(ContentFlex, {
    direction: CONTENT_DIRECTION,
    fullWidth: true
  }, /*#__PURE__*/React.createElement(ContentWrapper, {
    center: center,
    $restrict: !hasRightButton,
    direction: 'ttb',
    fullWidth: true
  }, /*#__PURE__*/React.createElement(HeadingWrapper, {
    direction: 'ttb'
  }, kickerTitle && /*#__PURE__*/React.createElement(StyledH4, {
    lines: 2,
    inverse: true,
    textAlign: center ? 'center' : 'left'
  }, kickerTitle), /*#__PURE__*/React.createElement(StyledH1, {
    lines: 3,
    inverse: true,
    shadowed: true,
    textAlign: center ? 'center' : 'left'
  }, title)), bodyTitle && /*#__PURE__*/React.createElement(BodyWrapper, null, /*#__PURE__*/React.createElement(Base, {
    inverse: true,
    textAlign: center ? 'center' : 'left'
  }, bodyTitle)), listItems && listItems.length > 0 && /*#__PURE__*/React.createElement(ListWrapper, null, /*#__PURE__*/React.createElement(Ul, {
    listStyleNone: true,
    expanded: true,
    inline: LIST_INLINE,
    textAlign: listTextAlign,
    horizontalOffset: HERO_LIST_HORIZONTAL_OFFSET,
    verticalOffset: HERO_LIST_VERTICAL_OFFSET
  }, listItems)), centerButtonTitle && /*#__PURE__*/React.createElement(CenterButtonWrapper, {
    direction: "ltr",
    center: center
  }, /*#__PURE__*/React.createElement(Button, _extends({
    fullWidth: IS_MOBILE,
    title: centerButtonTitle,
    subTitle: centerButtonSubTitle,
    onClick: onCenterButtonClick
  }, centerButtonProps))), hintTitle && /*#__PURE__*/React.createElement(HintWrapper, null, /*#__PURE__*/React.createElement(Small, {
    inverse: true,
    textAlign: center ? 'center' : 'left'
  }, hintTitle))), hasRightButton && /*#__PURE__*/React.createElement(RightButtonWrapper, {
    $vertical: IS_MOBILE,
    $alignSelf: rightButtonAlignSelf
  }, priceTitle && /*#__PURE__*/React.createElement(PriceWrapper, null, /*#__PURE__*/React.createElement(PriceMedium, {
    inverse: true,
    textAlign: "center"
  }, priceTitle)), /*#__PURE__*/React.createElement(Button, _extends({
    fullWidth: IS_MOBILE,
    title: rightButtonTitle,
    subTitle: rightButtonSubTitle,
    onClick: onRightButtonClick
  }, rightButtonProps))))), linkTitle && /*#__PURE__*/React.createElement(LinkWrapper, {
    $show: showLink,
    center: hasCenteredLink
  }, /*#__PURE__*/React.createElement(StyledTextButton, _extends({
    $show: hasCenteredLink,
    noFocus: true,
    size: "small",
    variant: "inverse",
    iconRight: _ref8,
    vertical: verticalLink,
    onClick: onLinkClick
  }, linkProps), linkTitle), /*#__PURE__*/React.createElement(StyledTextButton, _extends({
    $hide: hasCenteredLink,
    noFocus: true,
    size: "small",
    variant: "inverse",
    iconRight: _ref9,
    vertical: verticalLink,
    onClick: onLinkClick
  }, linkProps), linkTitle)));
});
export default Hero;